import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { AvisoZona } from "../../../utils/Agenda";

// Aviso de que la agenda se ve en la hora del dispositivo y no en la de la clínica
interface ZonaHorariaDialogProps {
  open: boolean;
  aviso: AvisoZona | null;
  onClose: () => void;
}

const ZonaHorariaDialog = ({ open, aviso, onClose }: ZonaHorariaDialogProps) => (
  <Dialog open={open && aviso !== null} maxWidth="sm" onClose={onClose}>
    <DialogTitle>Tu hora no es la de la clínica</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 2 }}>
        En la clínica son las <strong>{aviso?.horaClinica}</strong> y en tu dispositivo, las <strong>{aviso?.horaLocal}</strong> ({aviso?.diferencia}).
      </DialogContentText>
      <DialogContentText sx={{ mb: 2 }}>
        La agenda muestra las citas en tu hora: una cita a las 10:00 en la clínica aparece aquí a las {aviso?.ejemploLocal}.
      </DialogContentText>
      <DialogContentText>Tenlo en cuenta al dar o cambiar citas.</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary" autoFocus>ENTENDIDO</Button>
    </DialogActions>
  </Dialog>
);

export default ZonaHorariaDialog;
